<div class="data-container w-full">
  <div class="w-full image-container">
    <img *ngIf="storeImage" class="img" src="{{ storeImage }}" alt="" />
  </div>

  <span class="amount">350MB </span>
  <span class="warning-title">MAXIMUM DATA USED</span>
  <span class="warning-subtitle">
    You have exceeded your maximum data usage for today at this store.
  </span>
</div>
